import { render, staticRenderFns } from "./PlaylistEmailView.vue?vue&type=template&id=0f8a7b8e"
import script from "./PlaylistEmailView.vue?vue&type=script&lang=js"
export * from "./PlaylistEmailView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports